import { Routes, Route, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router";
import { ApplicantProfileCitizenshipViewContainer } from "../components/applicant-profile-citizenship-view.container";
import { ApplicantProfileCitizenshipEditContainer } from "../components/applicant-profile-citizenship-edit.container";

export const ApplicantProfileCitizenship: React.FC = () => {
  const params = useParams();

  return (
    <div>
      <Helmet>
        <title>Applicant - Citizenship</title>
      </Helmet>
      <Routes>
          <Route index element={<Navigate to="view" replace />} />
          <Route path="view/*" element={<ApplicantProfileCitizenshipViewContainer applicantId={params.applicantId || ''} />} />
          <Route path="edit/*" element={<ApplicantProfileCitizenshipEditContainer applicantId={params.applicantId || ''} />} />
      </Routes>
    </div>
  );
};


